import { createReducer, on } from '@ngrx/store'
import * as InvoiceActions from './invoice.actions'
import { InvoiceEntity } from './invoice.models'

export const INVOICE_FEATURE_KEY = 'invoice'

export interface RootState {
  invoice: InvoiceState
}

export interface InvoiceState extends InvoiceEntity {
  loaded: boolean
}

export const initialState: InvoiceState = {
  amount_owed: '',
  amount_paid: '',
  amount_pending: '',
  auction: '',
  dispatch_status: '',
  fee_subtotal: '',
  fee_tax: '',
  fee_total: '',
  has_ioc: false,
  has_voucher: false,
  has_voucher_items: false,
  line_items: [],
  paid: false,
  profile: {
    address: '',
    auction: '',
    email: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    stripe_customer: '',
    table: '',
    user: '',
    uuid: '',
  },
  reference_number: 0,
  subtotal: '',
  tax_owed: '',
  tipping_fee: '',
  total: '',
  total_tax: '',
  loaded: true,
}

export const invoiceReducer = createReducer(
  initialState,
  on(InvoiceActions.clearInvoice, () => ({
    ...initialState,
  })),
  on(InvoiceActions.loadInvoice, (state) => ({
    ...state,
    loaded: false,
    error: '',
  })),
  on(InvoiceActions.loadInvoiceSuccess, (state, { invoice }) => ({
    ...invoice,
    error: '',
    loaded: true,
  })),
)
